<template>
  <div class="row">
    <div class="col-12 mb-2">
      <button class="btn btn-success btn-sm" @click="downloadTemplate()">
        <i class="fa fa-download me-1"></i> Download Template
      </button>
    </div>
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="col-12 mb-3">
        <label for="file" class="form-label">Select File</label>
        <input
          type="file"
          ref="fileInput"
          class="form-control"
          @change="handleFileChange"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          required
        />
        <div class="invalid-feedback">Please select a valid file.</div>
      </div>

      <div class="alert alert-success" role="alert" v-if="isFinished">
        <h4 class="alert-heading">Import Peserta Selesai</h4>
        <table>
          <tr>
            <td>Total Data</td>
            <td>:</td>
            <td>{{ totalData }}</td>
          </tr>
          <tr>
            <td>Total Berhasil</td>
            <td>:</td>
            <td>{{ totalSuccess }}</td>
          </tr>
          <tr>
            <td>Total Gagal</td>
            <td>:</td>
            <td>{{ totalFailed }}</td>
          </tr>
          <tr v-if="lineFailed.length > 0">
            <td>Baris Gagal</td>
            <td>:</td>
            <td>
              <template v-for="(line, index) in lineFailed" :key="index">
                <span v-if="index < lineFailed.length">{{ line }},</span>
                <span v-else>{{ line }}</span>
              </template>
            </td>
          </tr>
          <tr v-else>
            <td colspan="3" class="text-center">Tidak ada baris yang gagal</td>
          </tr>
        </table>
      </div>

      <div class="row mt-3" v-if="showProgress">
        <b-progress :max="totalData" height="2rem">
          <b-progress-bar :value="importedData" show-progress animated>
            <span>
              Progress: <strong>{{ importedData }} / {{ totalData }}</strong>
            </span>
          </b-progress-bar>
        </b-progress>
      </div>

      <!-- <div class="mb-3">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div> -->
    </form>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

export default {
  emits: ["submit"],
  data() {
    return {
      showProgress: false,
      totalData: 0,
      importedData: 0,
      isFinished: false,
      tempFile: "",
      importProgress: 0,
      isProccess: false,
      lineFailed: [], // untuk menampilkan baris yang gagal diimport
      totalSuccess: 0, // untuk menampilkan jumlah baris yang berhasil diimport
      totalFailed: 0, // untuk menampilkan jumlah baris yang gagal diimport
    };
  },
  methods: {
    async downloadTemplate() {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "download-template/pegawai-eksternal";
      window.open(url, "_blank");
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      // show loading
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            `master/pegawai-eksternal/preview-import`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log({ repsonseData: response.data });
          this.totalData = response.data.data.total; // untuk progress bar
          this.tempFile = response.data.data.tempFile; // misal backend kasih token/tempFile
          Swal.fire({
            icon: "info",
            title: "Preview Data",
            html: `<p>Total Data: ${this.totalData}</p>`,
            showCancelButton: true,
            confirmButtonText: "Import Data",
            cancelButtonText: "Batal",
          }).then((result) => {
            if (result.isConfirmed) {
              this.submitForm();
            }
          });
          // console.log("Total Data:", response.data.total);
          // this.totalData = response.data.total; // untuk progress bar
          // this.tempFile = response.data.tempFile; // misal backend kasih token/tempFile
        })
        .catch((error) => {
          console.error("Preview Error:", error);
        });
    },

    submitForm() {
      this.showProgress = true;
      const chunkSize = 25;
      const totalChunks = Math.ceil(this.totalData / chunkSize);
      let currentChunk = 0;
      this.importedData =
        currentChunk * chunkSize > this.totalData
          ? this.totalData
          : currentChunk * chunkSize;

      const importChunk = () => {
        this.isProccess = true;
        if (currentChunk >= totalChunks) {
          this.isFinished = true;
          this.importProgress = 100; // set progress ke 100% jika sudah selesai
          this.showProgress = false; // sembunyikan progress bar
          this.isProccess = false;
          Swal.fire("Import selesai!", "Semua data telah diimport.", "success");
          this.$emit("submit", true); // emit event submit jika sudah selesai
          return;
        }

        axios
          .post(
            process.env.VUE_APP_BACKEND_URL_VERSION +
              `master/pegawai-eksternal/import-excel`,
            {
              tempFile: this.tempFile,
              chunk: currentChunk,
              chunkSize: chunkSize,
            },
            {
              headers: { Authorization: `Bearer ${localStorage.access_token}` },
            }
          )
          .then((response) => {
            console.log({ responseData: response.data });
            currentChunk++;
            this.importedData = Math.min(
              currentChunk * chunkSize,
              this.totalData
            );
            this.importProgress = Math.floor(
              (this.importedData / this.totalData) * 100
            );
            this.totalSuccess += response.data.data.success || 0;
            this.totalFailed += response.data.data.failed || 0;
            this.lineFailed = [
              ...this.lineFailed,
              ...(response.data.data.lineFailed || []),
            ];
            importChunk(); // rekursif: import chunk berikutnya
          })
          .catch((error) => {
            this.isProccess = false;
            console.error("Import Error:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat import.", "error");
          });
      };

      importChunk();
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here if needed */
</style>
